export default function MapLoader() {
  return (
    <div
      id="map-root"
      className="hidden desktop:block pb-[1.875rem] z-10 relative top-0 [&.is-sticky]:desktop:sticky [&.is-sticky]:desktop:top-[137px] flex-1 bg-[hsla(0,0%,100%,.6)]">
      <div className="w-full h-full flex justify-center pt-20">
        <svg
          viewBox="0 0 24 24"
          className="w-12 h-[3rem]"
          xmlns="http://www.w3.org/2000/svg">
          <circle fill="#ebbf20" cx="12" cy="12" r="0">
            <animate
              attributeName="r"
              calcMode="spline"
              dur="1.2s"
              values="0;11"
              keySplines=".52,.6,.25,.99"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              calcMode="spline"
              dur="1.2s"
              values="1;0"
              keySplines=".52,.6,.25,.99"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    </div>
  );
}
